/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePatientDto
 */
export interface CreatePatientDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    email?: string;
    /**
     * ISO date string
     * @type {string}
     * @memberof CreatePatientDto
     */
    dateOfBirth?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    gender?: CreatePatientDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePatientDto
     */
    address?: string;
}


/**
 * @export
 */
export const CreatePatientDtoGenderEnum = {
    Male: 'male',
    Female: 'female'
} as const;
export type CreatePatientDtoGenderEnum = typeof CreatePatientDtoGenderEnum[keyof typeof CreatePatientDtoGenderEnum];


/**
 * Check if a given object implements the CreatePatientDto interface.
 */
export function instanceOfCreatePatientDto(value: object): value is CreatePatientDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreatePatientDtoFromJSON(json: any): CreatePatientDto {
    return CreatePatientDtoFromJSONTyped(json, false);
}

export function CreatePatientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePatientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'address': json['address'] == null ? undefined : json['address'],
    };
}

export function CreatePatientDtoToJSON(json: any): CreatePatientDto {
    return CreatePatientDtoToJSONTyped(json, false);
}

export function CreatePatientDtoToJSONTyped(value?: CreatePatientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'dateOfBirth': value['dateOfBirth'],
        'gender': value['gender'],
        'phone': value['phone'],
        'address': value['address'],
    };
}

